
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles",
      function () {
        return require("private-next-pages/articles/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles"])
      });
    }
  